import { MOBILE_RESOLUTION } from '@/constants';
import { useWindowWidth } from './useWindowWidth';

export const useMobileWidth = () => {
  const width = useWindowWidth();
  const isMobile = width && width < MOBILE_RESOLUTION;

  return isMobile;
};
